/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Box, Button, Typography } from "@mui/material";
import { Lock } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

import { Loader } from "../../common/loader";
import {
  ROLES,
  TAILWIND_GRADIENT_SUBMIT_BUTTON_CLASS,
} from "../../helpers/constants";
import AlertDialog from "../../common/AlertDialog";
import { decryptPayload } from "../../helpers/utils";
import CardSection from "../../common/StripeCardForm";
import Aurthorised from "../../../assets/price_F&Q/aurthorize.png";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import PlainAlertMessage from "../../common/PlainAlertMessage";
import { savedCardOutcome } from "../add-property/savedCardSelection";

const AddCardForm = ({
  isTailwindComponent = false,
  adminWorkspace = false,
  openPopup,
  loader,
  fromAdmin = false,
  uid = null,
  onClose = () => {},
  handleCloseAddCardModal = () => {},
  callListingAPI = () => {},
  isOpenFromBottom = false,
  existingCardsForDuplicateCheck,
  isServiceProvider = false,
}) => {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stripeErr, setStripeErr] = useState("");
  const [retry, setRetry] = useState(false);
  const [alert, setAlert] = useState("");
  const [errAlert, setErrAlert] = useState(false);
  const isSubmittingRef = useRef(false);
  const stripe = useStripe();
  const elements = useElements();
  const isAssistant =
    decryptPayload(localStorage?.getItem("agent_role")) === ROLES?.assistant;
  const dispatch = useDispatch();

  // store data
  const { addNewCard, cardDetails, userProfileDetails, addNewCardLoader } =
    useSelector((state) => state?.userProfile);
  const { cardListData } = useSelector((state) => state?.propertyUsers);
  const { investorReportResultData, invToken } = useSelector(
    (state) => state?.propertyRiskManagement,
  );

  const releaseSubmitLock = () => {
    isSubmittingRef.current = false;
    setIsSubmitting(false);
    setOpen(false);
  };

  useEffect(() => {
    // Only react to an actual API response; clearing addNewCard at request start
    // must not unlock Save (that allowed double-submit races).
    if (Object.keys(addNewCard || {}).length > 0) {
      if (savedCardOutcome(addNewCard).kind === "duplicate") {
        keepExistingCard();
        return;
      }
      setAlert(addNewCard?.success);
      setErrAlert(addNewCard?.success);
      setRetry(true);
      releaseSubmitLock();
    }
  }, [addNewCard]);

  useEffect(() => {
    console.log("openPopup called==>>", openPopup);
    clearStates();
  }, []);

  const clearStates = () => {
    releaseSubmitLock();
    setStripeErr("");
    setRetry(false);
  };

  const handleLocalSubmitError = (message) => {
    setStripeErr(message || "");
    setRetry(false);
    releaseSubmitLock();
  };

  const keepExistingCard = () => {
    releaseSubmitLock();
    setStripeErr("");
    setRetry(false);
    handleCloseAddCardModal();
    onClose();
  };

  const validateErr = (event) => {
    console.log("validate error==>", event);
    setStripeErr("");
  };

  const normalizeCardBrand = (brand) =>
    String(brand || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");

  const getExistingCards = () => {
    if (Array.isArray(existingCardsForDuplicateCheck)) {
      return existingCardsForDuplicateCheck;
    }

    const profileCards = Array.isArray(cardDetails?.data)
      ? cardDetails.data
      : [];
    const adminCards = Array.isArray(cardListData?.data)
      ? cardListData.data
      : [];

    if (fromAdmin) {
      return profileCards.length > 0 ? profileCards : adminCards;
    }

    return profileCards;
  };

  const findDuplicateCard = (tokenCard) => {
    if (!tokenCard?.last4) {
      return null;
    }

    const tokenBrand = normalizeCardBrand(tokenCard.brand);

    return getExistingCards().find((existing) => {
      if (String(existing?.last4) !== String(tokenCard.last4)) {
        return false;
      }

      const existingBrand = normalizeCardBrand(existing?.brand);
      return !existingBrand || !tokenBrand || existingBrand === tokenBrand;
    });
  };

  const handleSubmit = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }
    // Prevent double/triple Save clicks from creating duplicate cards.
    if (isSubmittingRef.current || addNewCardLoader) {
      return;
    }
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setOpen(true);

    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      console.error(result.error.message);
      handleLocalSubmitError(result.error.message);
      return;
    }

    const duplicateCard = findDuplicateCard(result.token?.card);
    if (duplicateCard) {
      keepExistingCard();
      return;
    }

    setStripeErr("");
    stripeTokenHandler({ token: result.token.id });
  };

  const stripeTokenHandler = (data) => {
    console.log("Stripe Token Handler==>>", data);
    const isServicerAccount =
      isServiceProvider ||
      decryptPayload(localStorage.getItem("roles"))?.includes(
        ROLES.serviceProvider,
      );

    if (fromAdmin && !isServicerAccount) {
      dispatch(
        userProfileAction.addNewCard({
          url: `admin/users/${uid}/card`,
          data: data,
          token: !isAssistant,
          brokertoken: isAssistant,
        }),
      );
    } else if (isServicerAccount && !invToken) {
      const cardCreateUrl = uid
        ? `service-provider/customer/users/${uid}/card`
        : "service-provider/card/create";
      dispatch(
        userProfileAction.addNewCard({
          url: cardCreateUrl,
          data: data,
          token: true,
        }),
      );
    } else if (
      userProfileDetails?.data?.user_type?.includes(ROLES?.professional) &&
      !userProfileDetails?.data?.role?.includes(ROLES?.customer) &&
      !invToken
    ) {
      dispatch(
        userProfileAction.addNewCard({
          url: "professional/card/create",
          data: data,
          token: true,
        }),
      );
    } else {
      let url = "customer/card/create";
      let payload = data;
      if (invToken) {
        url = "investor-save-card";
        payload.investor_token = invToken;
        payload.user_id = investorReportResultData?.data?.user?.id;
      }
      console.log(url, "-----", payload);

      dispatch(
        userProfileAction.addNewCard({
          url,
          data: payload,
          token: true,
        }),
      );
    }
  };
  const tryAgain = () => {
    releaseSubmitLock();
    setRetry(false);
  };
  console.log("isOpenFromBottom", isOpenFromBottom);
  const cardAdded = () => {
    releaseSubmitLock();
    const isServicerAccount =
      isServiceProvider ||
      decryptPayload(localStorage.getItem("roles"))?.includes(
        ROLES.serviceProvider,
      );

    // Close modal first; refresh once via the correct listing path.
    // Avoid stacking customer/card/list + admin list (Redux takeEvery race).
    if (fromAdmin || invToken || isServicerAccount) {
      handleCloseAddCardModal();
      onClose();
      return;
    }

    handleCloseAddCardModal();

    if (addNewCard?.success && !invToken) {
      if (isServicerAccount) {
        dispatch(
          userProfileAction.userCardDetails({
            url: uid
              ? `service-provider/customer/users/${uid}/card`
              : "service-provider/card/list",
            data: {},
            token: true,
          }),
        );
      } else if (
        userProfileDetails?.data?.user_type?.includes(ROLES?.professional) &&
        !userProfileDetails?.data?.role?.includes(ROLES?.customer)
      ) {
        dispatch(
          userProfileAction.userCardDetails({
            url: "professional/card/list",
            data: {},
            token: true,
          }),
        );
      } else {
        dispatch(
          userProfileAction.userCardDetails({
            url: "customer/card/list",
            data: {},
            token: true,
          }),
        );
      }
    }
  };
  const useModernCardUi = isTailwindComponent || adminWorkspace;
  // Tailwind pages don't load the admin workspace stylesheet behind the
  // user-workspace-add-card-form classes, so they get the same layout here.
  const tw = (classes) => (isTailwindComponent ? ` ${classes}` : "");

  return (
    <>
      <Box
        className={`${useModernCardUi ? "user-workspace-add-card-form" : "p-3"} ${
          isTailwindComponent && "tailwind_component"
        }`}
      >
        {fromAdmin && !adminWorkspace && (
          <Button
            onClick={() => onClose()}
            className="modal-close-btn"
            style={{
              position: "absolute",
              right: 10,
              top: 15,
              background: "transparent",
            }}
          >
            <CloseIcon sx={{ color: "#9CB8A6" }} />
          </Button>
        )}
        {retry ? (
          <>
            {addNewCard?.success && !isOpenFromBottom && (
              <AlertDialog
                width="md"
                isTailwindComponent={isTailwindComponent}
                type="Success"
                openPopup={alert && !isOpenFromBottom}
                onClose={true}
                mesage={addNewCard?.message}
                loader={open}
                onCloseFun={cardAdded}
                buttons={
                  <Button
                    className="popup_Btn success_popup_btn"
                    onClick={cardAdded}
                  >
                    Ok, All Good
                  </Button>
                }
              />
            )}
            {!errAlert && !isOpenFromBottom && (
              <AlertDialog
                width="md"
                isTailwindComponent={isTailwindComponent}
                type="Error"
                openPopup={!errAlert && !alert && !isOpenFromBottom}
                onClose={true}
                mesage={addNewCard?.data?.message}
                onCloseFun={tryAgain}
                buttons={
                  <Button
                    className="popup_Btn error_popup_btn "
                    onClick={tryAgain}
                  >
                    Try again
                  </Button>
                }
              />
            )}
            {addNewCard?.success && isOpenFromBottom && (
              <PlainAlertMessage
                isTailwindComponent={isTailwindComponent}
                type="Success"
                openPopup={alert}
                onClose={true}
                message={addNewCard?.message}
                loader={open}
                onCloseFun={cardAdded}
                buttons={
                  <Button
                    className="popup_Btn success_popup_btn"
                    onClick={cardAdded}
                  >
                    Ok, All Good
                  </Button>
                }
              />
            )}
            {!errAlert && isOpenFromBottom && (
              <PlainAlertMessage
                isTailwindComponent={isTailwindComponent}
                type="Error"
                openPopup={!errAlert && !alert}
                onClose={true}
                message={addNewCard?.data?.message}
                onCloseFun={tryAgain}
                buttons={
                  <Button
                    className="popup_Btn error_popup_btn "
                    onClick={tryAgain}
                  >
                    Try again
                  </Button>
                }
              />
            )}
          </>
        ) : (
          <Box
            className={
              isTailwindComponent
                ? "mx-auto w-full max-w-lg px-4 py-6 text-left"
                : undefined
            }
          >
            {adminWorkspace ? (
              <Typography className="user-workspace-add-card-form__subtitle">
                Enter the card to save for subscription billing on this account.
              </Typography>
            ) : null}
            <CardSection
              stripeErr={stripeErr}
              validateErr={validateErr}
              variant={useModernCardUi ? "modern" : "legacy"}
            />
            <div
              className={
                useModernCardUi
                  ? `user-workspace-add-card-form__actions m-3${tw("mx-0 mt-6")}`
                  : "text-center stepBtn mt-5"
              }
            >
              <Button
                disabled={!stripe || isSubmitting || addNewCardLoader || open}
                type="submit"
                className={
                  useModernCardUi
                    ? `user-workspace-add-card-form__submit${tw(
                        `${TAILWIND_GRADIENT_SUBMIT_BUTTON_CLASS} mb-0 w-full normal-case`,
                      )}`
                    : `next_button mb-3 ${
                        isTailwindComponent &&
                        " bg-secondary hover:bg-secondary/90 text-secondary-foreground h-12 rounded-full font-semibold"
                      }`
                }
                variant="contained"
                onClick={handleSubmit}
              >
                {isSubmitting || addNewCardLoader || open
                  ? "Saving..."
                  : useModernCardUi
                    ? "Save card"
                    : "Next Step"}
              </Button>
            </div>
            {useModernCardUi ? (
              <div
                className={`user-workspace-add-card-form__footer m-3${tw(
                  "mx-0 mt-6 border-t border-border pt-4",
                )}`}
              >
                <div
                  className={`user-workspace-add-card-form__secure${tw(
                    "flex items-center justify-center gap-2 text-xs text-muted-foreground",
                  )}`}
                >
                  <Lock className="h-3.5 w-3.5 text-muted-foreground" />
                  <span>
                    Secure payments powered by{" "}
                    <span style={{ color: "#635BFF", fontWeight: 700 }}>
                      Stripe
                    </span>
                  </span>
                </div>
                <div
                  className={`user-workspace-add-card-form__brands${tw(
                    "mt-3 flex items-center justify-center gap-2",
                  )}`}
                >
                  <span
                    className={`user-workspace-add-card-form__brand-pill${tw(
                      "rounded px-2 py-0.5 text-[9px] font-bold leading-tight text-white",
                    )}`}
                    style={{ backgroundColor: "#EB001B" }}
                  >
                    MasterCard
                  </span>
                  <span
                    className={`user-workspace-add-card-form__brand-pill${tw(
                      "rounded px-2 py-0.5 text-[9px] font-bold leading-tight text-white",
                    )}`}
                    style={{ backgroundColor: "#1A1F71" }}
                  >
                    VISA
                  </span>
                  <span
                    className={`user-workspace-add-card-form__brand-pill${tw(
                      "rounded px-2 py-0.5 text-[9px] font-bold leading-tight text-white",
                    )}`}
                    style={{ backgroundColor: "#006FCF", fontSize: "8px" }}
                  >
                    AMEX
                  </span>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <hr />
                <img src={Aurthorised} alt="Aurthorised" />
              </div>
            )}
          </Box>
        )}
      </Box>
      <Loader open={open || loader || addNewCardLoader || isSubmitting} />
    </>
  );
};

export default AddCardForm;
